import { ReactElement } from 'react';

interface Props {
  className?: string;
}

export function PayrollDeductionIcon({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      fill="none"
      viewBox="0 0 39 38"
      className={`stroke-primary-main ${className}`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M33.5 17h-28m28 0a4 4 0 014 4v12a4 4 0 01-4 4h-28a4 4 0 01-4-4V21a4 4 0 014-4m28 0v-4a4 4 0 00-4-4m-24 8v-4a4 4 0 014-4m20 0V5a4 4 0 00-4-4h-12a4 4 0 00-4 4v4m20 0h-20"
      ></path>
    </svg>
  );
}
